export default function formatNumberToString(x: number, floatSep = ',') {
  var parts = x.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

  return parts.join(floatSep)
}
